'use strict';
module.exports = require('store2').namespace('groups');



//////////////////
// WEBPACK FOOTER
// ./src/main/scripts/modules/utils/store.js
// module id = JOWb
// module chunks = 1 2